import { type ReactNode } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT } from '@mentimeter/editor-slides-popover/src/components/AddSlidePopover/AddSlidePopover';
import { SIDEBAR_BAR_HEIGHT_MOBILE } from '@mentimeter/editor-properties-pane/src/constants';

interface EditorMobileLayoutProps {
  isPaneOpen: boolean;
  canvas: ReactNode;
  slidesOverview: ReactNode;
  sidebar: ReactNode;
}

export function EditorMobileLayout({
  isPaneOpen,
  canvas,
  slidesOverview,
  sidebar,
}: EditorMobileLayoutProps) {
  return (
    <Box
      as="main"
      display="flex"
      flexDirection="column"
      height="100%"
      alignItems="initial"
      flex="1 1 auto"
      width="100%"
      bg="surfaceSunken"
    >
      <Box
        flex={isPaneOpen ? 'unset' : 1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        p="space2"
      >
        {canvas}
      </Box>
      <Box
        id="editor-overview-container"
        height={isPaneOpen ? '0rem' : EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT}
        flexDirection="row"
        pl="space2"
      >
        {slidesOverview}
      </Box>
      <Box
        height={isPaneOpen ? 'unset' : SIDEBAR_BAR_HEIGHT_MOBILE}
        flex={isPaneOpen ? 1 : 'unset'}
      >
        {sidebar}
      </Box>
    </Box>
  );
}
